module.exports = __webpack_public_path__ + "static/media/product-blue.2931ecb6.svg";